var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-success-verification"},[_c('div',{staticClass:"phone-success-verification__num"},[_c('span',[_vm._v("Phone: ")]),_c('strong',[_vm._v(" +("+_vm._s(_vm.phoneCode)+")"+_vm._s(_vm.phone))])]),_c('div',{staticClass:"phone-success-verification__icon"},[_c('CheckIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }